import $ from "jquery-slim";
import { get } from "lodash";
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

import { gamePlayTime, getCountry, getLang } from "../../helpers/storage";
import Background from "../../components/Background";
import GameClosedView from "../OpeningScreen/GameClosedView";
import CONTENT from "../../data/content.json";

import style from "./style.module.css";

const Layout = () => {
    const [dimensions, setDimensions] = useState({ height: 0, winWidth: window.innerWidth, winHeight: window.innerHeight });
    const [winnings, setWinnings] = useState(0);
    const [time, setTime] = useState(gamePlayTime);
    const [gameSessionId, setGameSessionId] = useState('');
    const { pathname } = useLocation();

    useEffect(() => {
        function updateDimensions() {
            setDimensions({
                winWidth: $(window).width(),
                winHeight: $(window).height(),
            });
        }
        window.addEventListener('resize', updateDimensions);
        updateDimensions();
        return () => {
            window.removeEventListener('resize', updateDimensions);
        }
    }, []);

    useEffect(() => {
        if (pathname === '/') {
            setGameSessionId('');
            setWinnings(0);
            setTime(gamePlayTime);
        }
    }, [pathname])

    const contextObject = {
        height: dimensions.height,
        winWidth: dimensions.winWidth,
        winHeight: dimensions.winHeight,
        winnings,
        setWinnings,
        time,
        setTime,
        gameSessionId,
        setGameSessionId,
    }

    const desktopBackground = get(CONTENT, `data.opening_screen.content.${getLang()}.background_image_desktop`);
    const mobileBackground = get(CONTENT, `data.opening_screen.content.${getLang()}.background_image_mobile`);
    const isGameOn = get(CONTENT, `data.settings.content.${getCountry()}.on`) === "1";
    const closedContent = get(CONTENT, `data.closed.content.${getLang()}`, {});

    return (
        <>
            <div className={style.content}>
                <>
                    <>
                        {
                            dimensions.winWidth > 1024 && (
                                <Background className={style.background} src={desktopBackground} alt="Penhaligon's Desktop Background" />
                            )
                        }
                        {
                            dimensions.winWidth <= 1024 && (
                                <Background className={style.background} src={mobileBackground} alt="Penhaligon's Mobile Background" />
                            )
                        }
                    </>
                    <div className={style.outletWrap}>
                        <>
                            {
                                isGameOn === true && (
                                    <Outlet context={{ ...contextObject, content: CONTENT }} />
                                )
                            }
                            {
                                isGameOn === false && (
                                    <>
                                        <GameClosedView closedContent={closedContent} />
                                        {
                                            pathname !== '/' && (
                                                <Navigate to="/" replace />
                                            )
                                        }
                                    </>
                                )
                            }
                        </>
                    </div>
                </>
            </div>
        </>
    )
}

export default Layout;